<template>
  <div
    class="trustpilot-widget"
    data-locale="de-DE"
    :data-template-id="templateId"
    data-businessunit-id="50664da000006400051c4308"
    :data-style-height="height"
    data-style-width="100%"
    data-theme="light"
    data-stars="4,5"
    data-review-languages="de"
  >
    <a href="https://de.trustpilot.com/review/pflege.de" target="_blank" rel="noopener">
      Trustpilot
    </a>
  </div>
</template>

<script>
export default {
  name: 'Trustpilot',
  props: {
    type: {
      type: String,
      default: 'small',
      validator: (val) => ['slider', 'small'].includes(val),
    },
    height: {
      type: Number,
      default: 240,
    },
  },
  data() {
    let templateId = '54ad5defc6454f065c28af8b'; // id for slider
    if (this.type === 'small') {
      templateId = '5419b732fbfb950b10de65e5'; // id for small widget
    }

    return {
      templateId,
      el: 'o-trustpilot',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  mounted() {
    let script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute(
      'src',
      'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
    );
    script.onload = this.loadWidget();
    document.body.appendChild(script);
  },
  methods: {
    loadWidget() {
      if (!window.Trustpilot) {
        setTimeout(() => {
          this.loadWidget();
        }, 10);
      } else {
        window.Trustpilot.loadFromElement(this.$el, true);
      }
    },
  },
};
</script>
